<div class="container mt-4">
  <h2>Product Downloads</h2>

  <app-feedback [settings]="feedbackSettings"></app-feedback>

  <div class="row mt-3">
    <div class="col-12 col-md-auto">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Pricat</h5>
          <p class="card-text">Genereer en download Pricat bestanden.</p>

          <button
            class="btn btn-primary"
            (click)="generatePricat()"
            [disabled]="generatingPricat"
          >
            <span *ngIf="!generatingPricat"> <i class="fa-solid fa-plus me-1"></i> Genereer Pricat </span>
            <span *ngIf="generatingPricat">
              <span class="spinner-border spinner-border-sm me-1"></span>
              Bezig...
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-auto mt-3 mt-md-0">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">BMeCat</h5>
          <p class="card-text">Genereer en download BMeCat bestanden.</p>

          <button
            class="btn btn-primary"
            (click)="generateBmecat()"
            [disabled]="generatingBmecat"
          >
            <span *ngIf="!generatingBmecat"> <i class="fa-solid fa-plus me-1"></i> Genereer BMeCat </span>
            <span *ngIf="generatingBmecat">
              <span class="spinner-border spinner-border-sm me-1"></span>
              Bezig...
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3">
    <div class="card-body">
      <table
        class="table table-hover"
        *ngIf="downloads.length > 0"
      >
        <thead>
          <tr>
            <th>Type</th>
            <th>Bestand</th>
            <th>Status</th>
            <th>Resultaat</th>
            <th>Voortgang</th>
            <th>Gestart</th>
            <th>Grootte</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let job of downloads">
          <tr>
            <td>{{ job.functionName }}</td>
            <td>{{ job.displayName || job.filename || '...' }}</td>
            <td>
              <span
                *ngIf="job.status === DownloadJobStatus.FAILED"
                class="text-danger"
              >
                {{ getStatusLabel(job) }}
              </span>
              <span *ngIf="job.status !== DownloadJobStatus.FAILED">
                {{ getStatusLabel(job) }}
              </span>
            </td>
            <td>
              <ng-container *ngIf="hasSummary(job)">
                <span
                  class="badge rounded-pill"
                  [ngClass]="isComplete(job) ? 'text-bg-success' : 'text-bg-warning'"
                >
                  <i
                    class="fa-solid me-1"
                    [ngClass]="isComplete(job) ? 'fa-check' : 'fa-triangle-exclamation'"
                  ></i>
                  {{ resultBadgeLabel(job) }}
                </span>
                <button
                  *ngIf="hasDetails(job)"
                  type="button"
                  class="btn btn-link btn-sm p-0 ms-2 align-baseline"
                  (click)="toggleExpanded(job)"
                >
                  {{ isExpanded(job) ? 'Verberg' : 'Details' }}
                </button>
              </ng-container>
            </td>
            <td>
              <div
                class="progress"
                style="min-width: 120px"
                *ngIf="job.status === DownloadJobStatus.QUEUED || job.status === DownloadJobStatus.RUNNING"
              >
                <div
                  class="progress-bar progress-bar-striped progress-bar-animated"
                  [class.progress-bar-indeterminate]="isIndeterminate(job)"
                  role="progressbar"
                  [style.width.%]="isIndeterminate(job) ? 100 : getProgressPercent(job)"
                ></div>
              </div>
              <small
                class="text-muted d-block"
                *ngIf="job.status === DownloadJobStatus.QUEUED || job.status === DownloadJobStatus.RUNNING"
                >{{ getProgressPercent(job) }}%</small
              >
              <span *ngIf="job.status === DownloadJobStatus.READY">100%</span>
              <span
                *ngIf="job.status === DownloadJobStatus.FAILED"
                class="text-danger"
                >-</span
              >
            </td>
            <td>{{ job.startedAt | date: 'short' }}</td>
            <td>
              {{
                job.fileSizeBytes !== null && job.fileSizeBytes !== undefined ? formatFileSize(job.fileSizeBytes) : ''
              }}
            </td>
            <td>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="downloadFile(job)"
                [disabled]="job.status !== DownloadJobStatus.READY"
              >
                <i class="fa-solid fa-download"></i> Download
              </button>
            </td>
          </tr>
          <tr *ngIf="isExpanded(job)">
            <td
              colspan="8"
              class="bg-light"
            >
              <div class="small">
                <div class="mb-1">{{ completenessText(job) }}</div>
                <div
                  *ngIf="job.rejectedRows && job.rejectedRows > 0"
                  class="mb-1"
                >
                  <i class="fa-solid fa-triangle-exclamation text-warning me-1"></i>
                  <span class="fw-semibold">{{ job.rejectedRows }} overgeslagen</span>
                  &mdash; ongeldige data; zie het notities-bestand in de download voor de betreffende SKU's.
                </div>
                <div
                  *ngIf="job.adjustmentCount && job.adjustmentCount > 0"
                  class="text-muted"
                >
                  <i class="fa-solid fa-circle-info me-1"></i>
                  {{ job.adjustmentCount }} waarde(n) automatisch aangepast (afronding/normalisatie). Geen actie nodig.
                </div>
              </div>
            </td>
          </tr>
          </ng-container>
        </tbody>
      </table>

      <p
        *ngIf="downloads.length === 0"
        class="text-muted mt-2"
      >
        Geen downloads beschikbaar.
      </p>
    </div>
  </div>
</div>
